import { DefaultAPIInstance } from "@/api";

const profile_url = 'users/';

export const ProfileAPI = {
    getProfile(userId) {
        return DefaultAPIInstance.get(`${profile_url}${userId}/`)
    },
    updateProfile(userId, userData) {
        return DefaultAPIInstance.patch(`${profile_url}${userId}/update-profile/`, userData)
    },
    settingMessage(userId, userData) {
        return DefaultAPIInstance.patch(`${profile_url}${userId}/`, userData)
    },
    changePassword(userId, userData) {
        return DefaultAPIInstance.put(`${profile_url}${userId}/change-password/`, userData)
    },
    verification(userId, token) {
        return DefaultAPIInstance.get(`${profile_url}${userId}/update-email/${token}`)
    },
}
